module.exports = __webpack_public_path__ + "img/TreasureHunter.8cc910e7.png";